<template>
    <div class="filterContainer" v-if="showFilter" @click="openFilterSelectPopup" :class="[isThisPopUpOpen ? 'filterOpen' : '', userIsAuthenticated ? 'auth' : '']">
        <div class="filterIconContainer"  v-if="$store.getters.isMobile">
            <img :src="require(`../assets/${filter.icon}`)" class="filterIcon"/>
        </div>

        <div class="filterDetails">
            <div class="filterDisplayName">
                {{ this.filter.displayString }}
            </div>
            <div class="criteriaSelected" v-show="criteriaSelected" v-if="$store.getters.isMobile">
                {{ displayMobileSelectedCriteria }}
            </div>
            <div class="criteriaSelected" v-show="criteriaSelected" v-else>
                <div v-for="(display, index) in displaySelectedCriteria" :key=index class="selectedDisplay">
                    {{ display }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'filter'
        ],
        data() {
            return {
            }
        },
        computed: {
            showFilter() {
                let show = (!this.filter.authRequired || this.$store.getters.isLoggedIn);

                return show;
            },
            selected() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'filter_modal','event_label': eventLabel});
                
                return this.$store.getters.getFilterSelectedByName(this.filter.name);
            },
            iconSrc() {
                return require('@/assets/' + this.filter.icon);
            },
            criteriaSelected() {
                let selectionMade = false;

                if(this.filter.type == "array") {
                    selectionMade = this.selected.length > 0;
                }
                else if(this.filter.type == "object" || this.filter.type == "quick") {
                    selectionMade = Object.keys(this.selected).length > 0;
                }
                else if(this.filter.type == "range") {
                    selectionMade = (this.selected.min && (this.selected.min != this.filter.default.min)) || (this.selected.max && (this.selected.max != this.filter.default.max));
                }
                else {
                    selectionMade = this.selected;
                }
                
                return selectionMade;
            },
            displaySelectedCriteria() {
                let selectedDisplay =[];

                if (this.filter.type == "boolean") {
                    selectedDisplay.push(this.filter.displayString);
                }
                else if(this.filter.type == "range") {
                    selectedDisplay.push(this.getRangeDisplay());
                }
                else if(this.filter.type == "array") {
                    selectedDisplay = this.selected;
                }
                else if(this.filter.type == "object") {
                    selectedDisplay = this.$store.getters.getSelectedOfObjectTypeFilterByName(this.filter.name);
                }
                else if(this.filter.type == "quick") {
                    selectedDisplay.push(this.selected.display);
                }

                return selectedDisplay;
            },
            /*displayLengthLimit() {
                return (window.innerWidth * .01 * 31 * 2);
            },*/
            displayMobileSelectedCriteria() {
                let selectedDisplay = "";

                if (this.filter.type == "boolean") {
                    selectedDisplay = this.filter.displayString;
                }
                else if(this.filter.type == "range") {
                    selectedDisplay = this.getRangeDisplay();
                }
                else if(this.filter.type == "array") {
                    for(var d = 0; d < this.selected.length; d++) {
                        if(d > 0) {
                            selectedDisplay += ', ';
                        }

                        selectedDisplay += this.selected[d];
                    }
                }
                else if(this.filter.type == "object") {
                    let objectSelected = this.$store.getters.getSelectedOfObjectTypeFilterByName(this.filter.name);

                    for(var o = 0; o < objectSelected.length; o++) {
                        if(o > 0) {
                            selectedDisplay += ', ';
                        }

                        selectedDisplay += objectSelected[o];
                    }
                }
                else if(this.filter.type == "quick") {
                    selectedDisplay = this.selected.display;
                }

                /*if(selectedDisplay && this.displayVisualLength(selectedDisplay) > this.displayLengthLimit) {
                    selectedDisplay = this.trimDisplay(selectedDisplay);
                }*/

                return selectedDisplay;
            },
            isThisPopUpOpen() {
                return this.filter.name == this.$store.getters.getFilterSelectOpen;
            },
            userIsAuthenticated() {
                return this.$store.getters.isLoggedIn;
            }
        },
        methods: {
            openFilterSelectPopup(event) {
                if(this.filter.name == 'buy_now' || this.filter.type == 'boolean') {
                    this.$store.commit('updateFilterSelection', {name: this.filter.name, selected: !this.filter.selected});
                    this.$store.commit('notifySearchQueryChanges', true);
                }
                else {
                    this.$store.commit('updateFilterSelectOpen',this.filter.name);
                }
                event.stopPropagation();
            },
            getRangeDisplay() {
                let rangeString = null;

                if(this.selected.min || this.selected.max) {
                    var rangeSeporator = '-'; //'\u2194';
                    var nf = Intl.NumberFormat();
                    let prefix = (this.filter.name == 'year' || this.filter.name == "mileage") ? "" : "$";
                    
                    rangeString = prefix;
                    
                    if(this.selected.min) {
                        rangeString += this.filter.name != 'year' ? nf.format(this.selected.min) : this.selected.min;
                    }
                    else {
                        rangeString += this.filter.name != 'year' ? nf.format(this.filter.default.min) : this.filter.default.min;
                    } 
                    
                    rangeString +=  " " + rangeSeporator + " "+ prefix;
                    
                    if(this.selected.max) {
                        rangeString += this.filter.name != 'year' ? nf.format(this.selected.max) : this.selected.max;
                    }
                    else {
                        rangeString += this.filter.name != 'year' ? nf.format(this.filter.default.max) : this.filter.default.max;
                    }
                }

                return rangeString;
            },
            displayVisualLength(string) {
                var ruler = document.getElementById("ruler");
    
                ruler.innerHTML = string;
                return ruler.offsetWidth;
            },
            trimDisplay(display) {
                let elipseReplacement = " ...";
                let elipseReplacementLength = this.displayVisualLength(elipseReplacement);
                let displayParts = display.split(" ");
                let trimedDisplay = "";
                let end = false;
                let trimCount = 0

                while(!end && trimCount < displayParts.length) {
                    let nextPart = "";
                    
                    if(trimCount > 0) {
                        nextPart += " ";
                    }

                    nextPart += displayParts[trimCount];

                    if(this.displayVisualLength(trimedDisplay + nextPart) < (this.displayLengthLimit - elipseReplacementLength)) {
                        trimedDisplay += nextPart;
                    }
                    else {
                        trimedDisplay += elipseReplacement;
                        end = true;
                    }

                    trimCount++;
                }
                
                return trimedDisplay;
            }
        }
    }
</script>

<style>
    .filterContainer {
        color: white;
        padding: calc(1.2 * var(--vh)) calc(1 * var(--vw));
        text-align: right;
        border-top: 1px solid #2B2A2B;
        border-bottom: 1px solid #545454;/*707f99;*/
        cursor: pointer;
    }

    .filterContainer:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        border-color: var(--mccluskeyGold); /*#AF873F;*/
        border-top: 1px solid;
    }

    .inmobile .filterContainer {
        color: black;
        padding: 0;
        height: calc(16 * var(--vh));
        width: calc(32 * var(--vw));
        text-align: center;
        border: none;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .inmobile .filterContainer.auth {
        height: calc(13 * var(--vh));
    }

    .inmobile.tabletstyle .filterContainer {
        width: calc(18 * var(--vw));
    }

    .inmobile.tabletstyle .landscape > .filterContainer {
        height: calc(30 * var(--vh));
    }

    .inmobile.tabletstyle .landscape > .filterContainer.auth {
        width: calc(16 * var(--vw));
    }

    .inmobile.tabletstyle .filterContainer.auth  {
        height: calc(16 * var(--vh));
    }

    .filterIconContainer {
        width: calc(10.5 * var(--vw));
        height: calc(10.5 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .tabletstyle .landscape .filterIconContainer {
        width: calc(8 * var(--vw));
        height: calc(8 * var(--vw));
    }

    .filterIcon {
        object-fit: cover;
        height: inherit;
        width: inherit;
    }

    .inmobile .filterDisplayName {
        font-size: 1.1em;
    }

    .filterDetails {
        display: flex;
        flex-direction: column;
    }

    .inmobile .filterDetails {
        height: calc((16 * var(--vh)) - (10.5 * var(--vw)));
        margin: calc(1 * var(--vw)) 0;
    }

    .inmobile .auth .filterDetails {
        height: calc((13 * var(--vh)) - (10.5 * var(--vw)));
    }

    .criteriaSelected {
        font-size: .86em;
        font-weight: lighter;
        font-style: italic;
        /*overflow-x: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        text-align: left;
    }

    .inmobile .criteriaSelected {
        justify-content: flex-start;
        text-align: center;
        margin: 0 calc(.25 * var(--vw));
        overflow-y: scroll;
        height: calc(8 * var(--vh));
    }

    ::-webkit-scrollbar {
        width: 0px;  /* remove scrollbar space */
        background: transparent;  /* optional: just make scrollbar invisible */
    }

    .filterOpen {
        background: linear-gradient(#DFDFDF, #FFFFFF);
        color: black;
    }
</style>